module.exports = __webpack_public_path__ + "media/images/logo-0fd2fc7d9a88f4aa9fa94f52b2eec57a.svg";